import { render, staticRenderFns } from "./requests-issue.vue?vue&type=template&id=589e5c57&scoped=true&"
import script from "./requests-issue.vue?vue&type=script&lang=js&"
export * from "./requests-issue.vue?vue&type=script&lang=js&"
import style0 from "./requests-issue.vue?vue&type=style&index=0&id=589e5c57&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "589e5c57",
  null
  
)

export default component.exports